import { makeStyles, Theme } from "@material-ui/core/styles"
import Typography from "@material-ui/core/Typography"
import React, { Fragment } from "react"
import Calendar from "Components/Calendar"

export default function CenteredTabs() {

    return (
        <Fragment>
            <Calendar channelName={'子账号'} />

            <Typography component="div">
                <pre style={{whiteSpace: 'pre-line'}}>
                    预约规则：<br />
                    {/* 1.物种日历：每天均可约（包括周末）；原则上每周最多一个需求；<br /> */}
                    {/* 1.吃货研究所：商务合作优先推周六日，周一至周五需提前沟通协调；原则上隔一周一个商务点位，每周最多一个需求；<br /> */}
                    1.未尽事宜请直接和账号运营同事沟通。<br />
                </pre>
                <pre style={{whiteSpace: 'pre-line'}}>
                    各点位详情：<br />
                    {/* 物种日历（发布时间 - 12:00）<br/> */}
                    {/* 吃货研究所 - 头条（发布时间 - 周一到五16:30；周六日17:30）<br /> */}
                    {/* 吃货研究所 - 二条（发布时间 - 周一到五16:30；周六日17:30）<br /> */}
                    {/* 果壳病人（发布时间 - 21:00）<br /> */}
                    我是科学家<br />
                    放大灯<br />
                </pre>
            </Typography>
            <div id="board_input_modal" />
        </Fragment>
    )
}
